// extracted by mini-css-extract-plugin
module.exports = {"Background":"CalculatorBackground_Background__8kiwt","Overlay":"CalculatorBackground_Overlay__Rt9I4","Img":"CalculatorBackground_Img__Mss-7"};